/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, ReactNode } from 'react';

import { animated, useSpring } from '@react-spring/web';

type Props = {
  active: boolean;
  children: ReactNode;
};

export const Boop = memo<Props>(props => {
  const [style] = useSpring(
    () => ({
      cancel: !props.active,
      loop: true,
      delay: 3000,
      from: { transform: `translate(2px, 0px)` },
      to: { transform: `translate(0px, 0px)` },
      config: { tension: 300, friction: 10 },
    }),
    [props.active],
  );

  return <animated.span style={style}>{props.children}</animated.span>;
});
